import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import Breadcrumbs from '@Components/Breadcrumbs';

const PageHeader = (
    {
      intl,
      title,
      breadcrumbDisable,
      breadcrumbItems,
      description,
      imageSrc,
      imageAlt,
      background = 'bg-brand--dark-blue',
      fullWidth = true,
    },
) => {
  const [fullDescription, setFullDescription] = useState(false);
  const fullWidthClass = fullWidth ? 'header__content--full-width' : '';
  const hasBreadcrumbClass = !breadcrumbDisable ? 'has-breadcrumbs' : '';

  const renderDescription = () => {
    if (!description) {
      return '';
    } else if (description.length < 250 || fullDescription) {
      return (
        <p className="content-block__description">
          {description}
        </p>
      );
    }

    return (
      <div className="content-block__description">
        {`${description.slice(0, 250)}...`}
        <div className="mt-s">
          <button className="button--link" onClick={() => setFullDescription(true)}>
            {intl.formatMessage({id: 'PageHeader.description.ReadMore'})}
          </button>
        </div>
      </div>
    );
  };

  const renderMedia = () => {
    if (!imageSrc) {
      return '';
    }
    return (
      <div className="header__media flex items-center justify-center">
        <img src={imageSrc} alt={imageAlt ? imageAlt : intl.formatMessage({id: 'PageHeader.Illustration.DefaultAlt'})}/>
      </div>
    );
  };

  return (
    <div className={`header header--text ${background}`}>
      <div className="header__wrapper wrapper">
        {!breadcrumbDisable && <Breadcrumbs breadcrumbItems={breadcrumbItems} />}
        <div className={`header__content content-block text--light-from-l ${fullWidthClass} ${hasBreadcrumbClass}`}>
          <h1 className="content-block__title">
            <span className='content-block__title-top'>{title}</span>
          </h1>
          {renderDescription()}
        </div>
        {renderMedia()}
      </div>
    </div>
  );
};

export default injectIntl(PageHeader);
